import { AjaxDispatcher, ActionCreator } from './ajax-dispatcher';
import {
    getUrlWithoutQueryString,
    QueryParameter,
    buildQueryParameters
} from './common';
import { initPaginator } from './main';

enum OrderSort {
    createdBy = 1,
    orderState = 2,
    currency = 3
}

export default class OrderFilter {
    filter(event: Event): void {
        event.preventDefault();
        const queryParameters = this.buildOrderQueryParameters();
        const action = new ActionCreator().reloadOrders(queryParameters);

        action.successAction = () => {
            initPaginator();
        };

        this.refreshUrl(queryParameters);
        new AjaxDispatcher().dispatchGetAction(action);
    }

    sort(event: Event): void {
        if (!(event.target instanceof Element)) {
            return;
        }

        const queryParameters = this.buildOrderQueryParameters();
        const action = new ActionCreator().reloadOrders(queryParameters);

        action.successAction = () => {
            initPaginator();
        };

        this.refreshUrl(queryParameters);
        new AjaxDispatcher().dispatchGetAction(action);
    }

    private buildOrderQueryParameters(): QueryParameter[] {
        return [
            { key: 'filterValue', value: this.getFilterValue() },
            { key: 'sortBy', value: this.getOrderSort(event) },
            { key: 'orderOwner', value: this.getOrderOwner() }
        ];
    }

    private getFilterValue(): string {
        const inputElement = <HTMLInputElement>(
            document.querySelector('input[name="FilterValue"]')
        );

        return inputElement ? inputElement.value : null;
    }

    private getOrderOwner(): string {
        const selectElement = <HTMLSelectElement>(
            document.querySelector('select[name="SelectedPerson"]')
        );

        return selectElement ? selectElement.value : null;
    }

    private getOrderSort(event: Event): OrderSort {
        const element = event.target as Element;
        const orderSort = Number.parseInt(element.getAttribute('data-sort'));

        return orderSort;
    }

    private refreshUrl(queryParameters: QueryParameter[]): void {
        const queryString = buildQueryParameters(queryParameters);
        const url = queryString
            ? getUrlWithoutQueryString() + '?' + queryString
            : getUrlWithoutQueryString();

        const newUrlState = { title: document.title, url: url };
        window.history.pushState(newUrlState, document.title, url);
    }
}
